import React,{useState}  from 'react';
import "./assets/scss/app.scss"
import MainRoutes from "./routes";
import languagePack from "./locale";
import {IntlProvider} from "react-intl";
import languages from './components/common/languages';



const App = () => {
    const [language, setLanguage] = useState(localStorage.locale === languages.en ? languages.en  : languages.vi);

    const onChangeLanguage = (value) => {
        localStorage.locale = value;
        setLanguage(value);
    }

    return (
        <IntlProvider locale={language} messages={languagePack[language]}>
            <MainRoutes onChangeLanguage={onChangeLanguage} language={language} />
        </IntlProvider>
    );
}

export default App;
